export const convertToLabel = (path: string | null): string => {
  if (!path) {
    return "";
  }
  return path
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
